var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body"},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header pb-2"},[_c('img',{attrs:{"src":"images/logos/bitacorapp-logo96x39.png","alt":""}})])
}]

export { render, staticRenderFns }